import logoTraid from "../assets/logo_orbitron_white.webp";

function PathSection() {
    return (
        <section
            id="path"
            aria-label="Path section"
            className="relative h-full bg-cover bg-center"
            style={{
                backgroundImage: 'url(/images/neuro_buildings.webp)',
            }}
        >
            <div className="flex flex-col items-center">
                <div className="flex flex-col mt-20">
                    <div className="flex justify-center">
                        <img
                            src={logoTraid}
                            alt="Logo traid"
                            className="w-1/3 mt-4"
                        />
                    </div>
                    <div className="flex flex-row justify-center">
                        <h2 className="font-[900] text-light text-[3vw] mt-8">
                            Deep learning per l'analisi dei{' '}
                            <span className="font-[900] text-green text-[3vw]">
                                mercati finanziari
                            </span>
                        </h2>
                    </div>
                </div>
                    <img src="/images/path_neuro.webp" alt="Path" className="w-[90%] my-[4vw]" />
            </div>
        </section>
    );
}

export default PathSection;
